import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';

export const STATUS_CONFIG = {
  ready: { labelKey: 'ready', color: 'success', Icon: CheckCircleOutlineIcon },
  warning: { labelKey: 'needs_review', color: 'warning', Icon: WarningAmberOutlinedIcon },
  existing: { labelKey: 'already_exists', color: 'default', Icon: PersonOffOutlinedIcon },
  error: { labelKey: 'cant_import', color: 'error', Icon: ErrorOutlineIcon },
};

export const STATUS_FILTERS = ['all', 'ready', 'warning', 'existing', 'error'];

export const SEVERITY_COLOR = { error: 'error', warning: 'warning', info: 'default' };

export const rowStatus = (row) => {
  if (row.issues.some((issue) => issue.severity === 'error')) return 'error';
  if (row.issues.some((issue) => issue.code === 'already_exists')) return 'existing';
  if (row.severity === 'warning') return 'warning';
  return 'ready';
};

export const CATEGORY_LABEL_KEYS = {
  email: 'category_email',
  notification_email: 'category_notification_email',
  name: 'category_name',
  role: 'category_role',
  phone: 'category_phone',
  password: 'category_password',
  balance: 'category_balance',
  delivery_address: 'category_delivery_address',
  invoice_address: 'category_invoice_address',
};

export const ROLE_OPTIONS = ['staff', 'manager', 'superadmin'];

export const EDITABLE_FIELD_GROUPS = [
  {
    key: 'basic',
    titleKey: 'section_basic_info',
    fields: [
      { name: 'name', labelKey: 'name', type: 'text' },
      { name: 'email', labelKey: 'email', type: 'text' },
      { name: 'notification_email', labelKey: 'notification_email', type: 'text' },
      { name: 'phone', labelKey: 'phone', type: 'text' },
      { name: 'role', labelKey: 'role', type: 'select', options: ROLE_OPTIONS },
      { name: 'password', labelKey: 'password', type: 'text' },
      { name: 'balance', labelKey: 'balance', type: 'text' },
    ],
  },
  {
    key: 'delivery',
    titleKey: 'section_delivery_address',
    fields: [
      { name: 'delivery_country', labelKey: 'country', type: 'text' },
      { name: 'delivery_address_one', labelKey: 'address', type: 'text' },
      { name: 'delivery_city', labelKey: 'city', type: 'text' },
      { name: 'delivery_postcode', labelKey: 'postcode', type: 'text' },
    ],
  },
  {
    key: 'invoice',
    titleKey: 'section_invoice_address',
    fields: [
      { name: 'invoice_country', labelKey: 'country', type: 'text' },
      { name: 'invoice_address_one', labelKey: 'address', type: 'text' },
      { name: 'invoice_city', labelKey: 'city', type: 'text' },
      { name: 'invoice_postcode', labelKey: 'postcode', type: 'text' },
    ],
  },
];
